import { Autorenew, Build, ChevronLeft } from '@mui/icons-material';
import batteryIcon from '../../assets/svg/batary.svg';
import carWashIcon from '../../assets/svg/CarCareIcon.svg';
import oilIcon from '../../assets/svg/ChangeOil.svg';
import maintenanceIcon from '../../assets/svg/Services Icons (1).svg';
import tireIcon from '../../assets/svg/Tire.svg';

const Servicess = () => {

  const services = [
    {
      id: 4,
      title: 'صيانه دوريه',
      price: '', 
      icon: maintenanceIcon,
      bg: '#F4F8F0', // Greenish
      hasTools: false 
    },
    {
      id: 3,
      title: 'بطاريه',
      price: '600.0',
      icon: batteryIcon,
      bg: '#FFF4F0', // Pinkish
      hasTools: true
    },
    {
      id: 2,
      title: 'كاوتش',
      price: '4.315',
      icon: tireIcon,
      bg: '#F8F8F8', // Grayish
      hasTools: true
    },
    {
      id: 1,
      title: 'زيوت و فلاتر',
      price: '1.110',
      icon: oilIcon,
      bg: '#FFFAEA', // Yellowish
      hasTools: true
    },
    {
      id: 5,
      title: 'كار كير',
      price: '', 
      icon: carWashIcon,
      bg: '#F0F8FF', // Bluish
      hasTools: false
    }
  ];

  return (
    <div className="container-fluid p-4" >
      
      {/* Container Card - mimicking the white box in image */}
      <div className="bg-white shadow-sm border rounded-4 p-4 mx-auto">
        
        {/* --- 1. Header --- */}
        <div className="text-end mb-4">
          <h5 className="fw-bold" style={{ fontSize: '1.2rem', color: '#333' }}>راجع الخدمات المنفذة من قبل الفني قبل تأكيد الطلب</h5>
        </div>

        {/* --- 2. Services Grid --- */}
        <div className="row g-3 mb-4 justify-content-end">
          {services.map((item) => (
            <div key={item.id} className="col-6 col-md-3">
              <div 
                className="position-relative d-flex flex-column align-items-center justify-content-center p-3 rounded-4 text-center"
                style={{ backgroundColor: item.bg, height: '180px', border: '1px solid rgba(0,0,0,0.02)' }}
              >
                
                {/* Top Corner Icons */}
                {item.hasTools && (
                  <>
                    <div className="position-absolute" style={{ top: '10px', left: '10px' }}>
                      <div className="bg-dark rounded-circle d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px' }}>
                        <Build style={{ color: 'white', fontSize: '14px' }} />
                      </div>
                    </div>
                    <div className="position-absolute" style={{ top: '10px', right: '10px' }}>
                      <div className="bg-dark rounded-circle d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px' }}>
                        <Autorenew style={{ color: 'white', fontSize: '14px' }} />
                      </div>
                    </div>
                  </>
                )}

                {/* Main Content */}
                <div className="bg-white rounded-circle d-flex align-items-center justify-content-center mb-3 shadow-sm" style={{ width: '60px', height: '60px' }}>
                  <img 
                    src={item.icon} 
                    alt={item.title} 
                    style={{ width: '35px', height: '35px', objectFit: 'contain' }} 
                  />
                </div>
                
                <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>{item.title}</p>
                
                {item.price && (
                  <p className="fw-bold mb-0" style={{ fontSize: '0.9rem' }}>
                    {item.price} <span className="small fw-normal">ج.م</span>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* --- 3. Footer Summary --- */}
        <div className="p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#eeeeee' }}>
           
           <div className="d-flex align-items-center gap-2 pe-3">
              <span className="fw-bold" style={{ fontSize: '0.9rem' }}>اجمالي تكلفة الخدمات : 6.225 ج.م</span>
           </div>

           <button className="btn bg-white shadow-sm border-0 rounded-3 d-flex align-items-center px-3 py-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
              <ChevronLeft fontSize="small" className="me-1"/>
              عرض التفاصيل
           </button>
        </div>

      </div>

      <div className="mt-4 text-center">
        <button 
          className="btn btn-secondary py-2 fw-bold text-white rounded-3 shadow-sm"
          style={{ backgroundColor: '#808080', minWidth: '200px' }} 
        >
          حفظ
        </button>
      </div>

    </div>
  )
}

export default Servicess;